import React from "react";
import PaymentDetailsRow from "./PaymentDetailsRow";
import styled from "@emotion/styled";

const MainLargeScreen = styled.div`
  @media (max-width: 425px) {
    display: none;
  }
`;

const MainGridLarge = styled.div`
  display: grid;
  grid-template-columns: 114px 107px 1fr 1fr auto;
  grid-row-gap: 20px;
  grid-column-gap: 10px;
  margin-bottom: 16px;

  @media (max-width: 530px) {
    grid-template-columns: 98px 90px 60px 1fr auto;
  }
  @media (max-width: 455px) {
    grid-template-columns: 92px 76px 62px 1fr auto;
  }
`;

const MainGridMobile = styled.div`
  @media (min-width: 426px) {
    display: none;
  }
`;

const GridItem = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #777984;

  @media (max-width: 530px) {
    font-size: 13px;
  }
  @media (max-width: 455px) {
    font-size: 12px;
  }
`;

const PaymentDetails = ({ payments, setCardSelected, setLoader }) => (
  <div>
    <MainLargeScreen>
      <MainGridLarge>
        <GridItem>Payment Date</GridItem>
        <GridItem>Payment ID</GridItem>
        <GridItem>Status</GridItem>
        <GridItem>Amount</GridItem>
        <GridItem></GridItem>
      </MainGridLarge>
      {payments.map((payment, key) => (
        <PaymentDetailsRow
          payment={payment}
          key={key}
          setCardSelected={setCardSelected}
          setLoader={setLoader}
        />
      ))}
    </MainLargeScreen>
    <MainGridMobile>
      {payments.map((payment, key) => (
        <PaymentDetailsRow
          payment={payment}
          key={key}
          setCardSelected={setCardSelected}
          setLoader={setLoader}
        />
      ))}
    </MainGridMobile>
  </div>
);

export default PaymentDetails;
